import { SvgIconProps } from '@material-ui/core/SvgIcon'
import * as React from 'react'

const SCALE = `0.8em`

/**
 * Icon illustrating that a feature is in development
 */
export const IconDevelop = (props: SvgIconProps): JSX.Element => {
  return (
    <svg
      width={SCALE}
      height={SCALE}
      viewBox={`0 0 40 40`}
      fill={`none`}
      xmlns={`http://www.w3.org/2000/svg`}
    >
      <path
        d={`M16.2643 1.74414L11.5193 19.4528L16.3489 20.7469L12.4666 35.2358L28.9121 18.9368L22.4726 17.2113L32.363 6.05779L16.2643 1.74414Z`}
        fill={`#969FA9`}
      />
      <path
        d={`M25.7 26.9998L16.6 17.8998C17.5 15.5998 17 12.8998 15.1 10.9998C13.1 8.99977 10.1 8.59977 7.7 9.69977L12 13.9998L9 16.9998L4.6 12.6998C3.4 15.0998 3.9 18.0998 5.9 20.0998C7.8 21.9998 10.5 22.4998 12.8 21.5998L21.9 30.6998C22.3 31.0998 22.9 31.0998 23.3 30.6998L25.6 28.3998C26.1 27.9998 26.1 27.2998 25.7 26.9998Z`}
        fill={`#1C1C1C`}
      />
    </svg>
  )
}
